import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { adminApi } from "../apis/admin-api";
import { AdminContext } from "../contexts/AdminContext";
import { LoadingContext } from "../contexts/LoadingContext";
import { IAdminField, ICompanyDetail } from "../interfaces/admin-interface";
import { adminFieldLeft, adminFieldRight } from "../sources/adminField";
import Button from "./Button";
import ConfirmPopup from "./ConfirmPopup";
import DatePicker from "./DatePicker";
import Input from "./Input";
import DeleteIcon from "../images/delete-icon.png";
import { ReactComponent as Loading } from "../images/loading.svg";

interface IAdminPopup {
  by: "create" | "edit";
  companyDetail?: ICompanyDetail | undefined;
  companiesName?: string[] | undefined;
  setCompanyDetail: Function;
  handleCreateAndEditCompany: Function;
}
const AdminPopup = ({
  by,
  companyDetail,
  setCompanyDetail,
  handleCreateAndEditCompany,
  companiesName,
}: IAdminPopup) => {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { setOpenAdminPopup } = useContext(AdminContext);
  const [isFieldComplete, setIsFieldComplete] = useState(false);
  const [fieldWrongFormats, setFieldWrongFormat] = useState<string[]>([]);
  const [confirmPopupIsOpen, setConfirmPopupIsOpen] = useState<boolean>(false);
  const [value, setValue] = useState<any>({
    id: companyDetail?.id || "",
    users: companyDetail?.users.map((e: any) => e.email) || [""],
    companyName: companyDetail?.companyName || "",
    domainName: companyDetail?.domainName || "",
    expiryDate: companyDetail?.expiryDate || `${new Date()}`,
    deleted: [],
    edited: [],
  });
  const [adminAccount, setAdminAccount] = useState<string[]>(
    companyDetail?.users.map((e: any) => e.email) || [""],
  );
  useEffect(() => {
    const keys = Object.keys(value);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === "expiryDate" || keys[i] === "deleted") {
        continue;
      }
      if (!value[keys[i]]) {
        setIsFieldComplete(false);
        break;
      } else if (value[keys[i]][0] === "") {
        setIsFieldComplete(false);
        break;
      } else {
        setIsFieldComplete(true);
      }
    }
  }, [value.users, value.deleted, value.companyName, value.domainName, value]);
  const handleRenderField = (field: IAdminField, index: number) => {
    if (field.type === "date") {
      return (
        <SFieldContainer key={index}>
          <STopic>{field.fieldLabel}</STopic>
          <SInputContainer>
            <DatePicker
              startDate={value[field.fieldName]}
              onSelect={(e: string) =>
                setValue({ ...value, [field.fieldName]: e })
              }
              rangeOn={false}
              addonCss={{ width: "93%", height: "40px" }}
            />
          </SInputContainer>
          {fieldWrongFormats.length &&
          fieldWrongFormats.indexOf(field.fieldName) > -1
            ? field.alert.map((e, i) => {
                return <SAlert key={i}>{e}</SAlert>;
              })
            : field.suggestion.map((e, i) => {
                return <SSuggestion key={i}>{e}</SSuggestion>;
              })}
        </SFieldContainer>
      );
    } else if (field.type === "input") {
      return (
        <SFieldContainer key={index}>
          <STopic>{field.fieldLabel}</STopic>
          <SInputContainer>
            <Input
              addonCss={
                fieldWrongFormats.length &&
                fieldWrongFormats.indexOf(field.fieldName) > -1
                  ? { border: "solid 1px red" }
                  : {}
              }
              placeholder={field.placeholder}
              value={value[field.fieldName]}
              onChange={(e: string) => {
                if (field.fieldName === "companyName") {
                  setValue({
                    ...value,
                    [field.fieldName]: e.replace(" ", "-"),
                    id: value.companyName.toLowerCase().replace(" ", "-"),
                  });
                } else {
                  setValue({ ...value, [field.fieldName]: e });
                }
              }}
            />
          </SInputContainer>
          {fieldWrongFormats.length &&
          fieldWrongFormats.indexOf(field.fieldName) > -1
            ? field.alert.map((e, i) => {
                return <SAlert key={i}>{e}</SAlert>;
              })
            : field.suggestion.map((e, i) => {
                return <SSuggestion key={i}>{e}</SSuggestion>;
              })}
        </SFieldContainer>
      );
    } else if (field.type === "multiInput") {
      return (
        <SFieldContainer key={index}>
          <STopic>{field.fieldLabel}</STopic>

          {adminAccount.map((l, i) => {
            return (
              <>
                <SInputContainer key={i}>
                  <Input
                    addonCss={
                      fieldWrongFormats.length &&
                      fieldWrongFormats.indexOf(`${field.fieldName}${i}`) > -1
                        ? { border: "solid 1px red" }
                        : {}
                    }
                    placeholder={field.placeholder}
                    value={value.users[i]}
                    onChange={(e: string) => {
                      const result = adminAccount;
                      result[i] = e;
                      setAdminAccount(result);
                      if (companyDetail?.users[i]) {
                        setValue({
                          ...value,
                          [field.fieldName]: result,
                          edited: [
                            ...value.edited,
                            companyDetail?.users[i].email,
                          ].reduce(function (a, b) {
                            if (a.indexOf(b) < 0) a.push(b);
                            return a;
                          }, []),
                        });
                      } else {
                        setValue({ ...value, [field.fieldName]: result });
                      }
                    }}
                  />
                  {adminAccount.length !== 1 && (
                    <SIcon
                      onClick={() => {
                        const result = adminAccount;
                        const deleting = adminAccount[i];
                        setValue({
                          ...value,
                          [field.fieldName]: result,
                          deleted: [...value.deleted, deleting],
                        });
                        result.splice(i, 1);
                        setAdminAccount(result);
                      }}
                    >
                      <img src={DeleteIcon} alt="delete icon" />
                    </SIcon>
                  )}
                </SInputContainer>
                {fieldWrongFormats.length &&
                fieldWrongFormats.indexOf(`${field.fieldName}${i}`) > -1
                  ? field.alert.map((e, i) => {
                      return <SAlert key={i}>{e}</SAlert>;
                    })
                  : field.suggestion.map((e, i) => {
                      return <SSuggestion key={i}>{e}</SSuggestion>;
                    })}
              </>
            );
          })}
          <SAddDomain
            onClick={() => {
              setAdminAccount([...adminAccount, ""]);
            }}
          >
            + Add New
          </SAddDomain>
        </SFieldContainer>
      );
    }
  };

  const handleSave = async () => {
    if (!isFieldComplete) return;
    const keys = Object.keys(value);
    setFieldWrongFormat([]);
    const wrongFormat: string[] = [];

    keys.forEach((key: string) => {
      if (key === "users") {
        const check = value[key].filter((e: any) => e !== "");
        if (!check.length) {
          wrongFormat.push(`${key}0`);
        } else {
          value[key].forEach((e: string, i: number) => {
            const sp = e.split("@");
            if (!sp[0] || sp[1] !== "gopomelo.com") {
              if (!sp[0] || sp[1] !== value.domainName) {
                wrongFormat.push(`${key}${i}`);
              }
            }
          });
        }
      }
      if (key === "companyName") {
        // eslint-disable-next-line no-useless-escape
        var format = /[`!@#$%^&*()+\-=\[\]{};':"\\|,.<>\/?~]/;
        if (format.test(value[key])) {
          wrongFormat.push(key);
        } else {
          if (by === "create") {
            const companyIndex: any = companiesName?.indexOf(value?.[key]);
            if (companyIndex > -1) {
              wrongFormat.push(key);
            }
          }
        }
      }
      if (key === "domainName") {
        if (
          (value[key].slice(value[key].length - 4, value[key].length) !==
            ".com" &&
            value[key].slice(value[key].length - 6, value[key].length) !==
              ".co.th" &&
            value[key].slice(value[key].length - 6, value[key].length) !==
              ".or.th") ||
          value[key].includes(" ")
        ) {
          wrongFormat.push(key);
        }
      }
    });
    if (wrongFormat.length) {
      setFieldWrongFormat(wrongFormat);
      return;
    }
    if (
      new Date(value.expiryDate) <= new Date(new Date().setHours(0, 0, 0, 0))
    ) {
      setConfirmPopupIsOpen(true);
    } else {
      if (by === "create") {
        setIsLoading({
          status: "inprogress",
          label: "Creating company details...",
        });
      } else if (by === "edit") {
        setIsLoading({
          status: "inprogress",
          label: "Saving company details...",
        });
      }
      const userFilter = value.users.filter((e: any) => e !== "");
      const deletedFilter = value.deleted.filter(
        (e: any) => e && companyDetail?.users.indexOf(e),
      );
      await adminApi.postSave(
        {
          ...value,
          users: userFilter,
          deleted: deletedFilter,
        },
        companyDetail?.id,
      );
      handleCreateAndEditCompany(by);
      setCompanyDetail(undefined);
    }
  };
  return (
    <SContainer>
      {confirmPopupIsOpen && (
        <ConfirmPopup
          header="Expiry Date"
          content={`The selected date is expired. 
Are you sure you want to save this date?`}
          confirm={{
            label: "CONFIRM",
            onClick: async () => {
              setConfirmPopupIsOpen(false);
              if (by === "create") {
                setIsLoading({
                  status: "inprogress",
                  label: "Creating company details...",
                });
              } else if (by === "edit") {
                setIsLoading({
                  status: "inprogress",
                  label: "Saving company details...",
                });
              }
              await adminApi.postSave({
                ...value,
              });
              handleCreateAndEditCompany(by);
              setOpenAdminPopup(undefined);
              setCompanyDetail(undefined);
            },
          }}
          cancel={{
            label: "CANCEL",
            onClick: () => {
              setConfirmPopupIsOpen(false);
            },
          }}
        />
      )}
      <SContent className={adminFieldRight.length ? "" : "oneside"}>
        <SHeader>
          <SLabel>
            {by === "create" ? "New Company" : "Edit Company Detail"}
          </SLabel>
          <SExit
            onClick={() => {
              setOpenAdminPopup(undefined);
              setCompanyDetail(undefined);
            }}
          >
            x
          </SExit>
        </SHeader>
        <SField>
          <SSide className={adminFieldRight.length ? "" : "oneside"}>
            {adminFieldLeft.map((e, i) => {
              return handleRenderField(e, i);
            })}
          </SSide>
          {adminFieldRight.length ? (
            <SSide>
              {adminFieldRight.map((e, i) => {
                return handleRenderField(e, i);
              })}
            </SSide>
          ) : (
            ""
          )}
        </SField>
        <SFooter>
          <SBottom>
            <Button
              onclick={() => {
                setCompanyDetail(undefined);
                setOpenAdminPopup(undefined);
              }}
              disable={isLoading?.status === "inprogress" ? true : false}
              addonCss={{
                border: "1px solid var(--color-border)",
                color: "var(--color-primary)",
                background: "var(--color-surface)",
                padding: "10px 24px",
              }}
            >
              {isLoading?.status === "inprogress" ? <Loading /> : "CANCEL"}
            </Button>
            <Button
              onclick={() => handleSave()}
              disable={isLoading?.status === "inprogress" ? true : false}
              addonCss={
                isFieldComplete
                  ? {
                      background: "#3C7FEC",
                      color: "white",
                      padding: "10px 28px",
                      fontWeight: 600,
                    }
                  : {
                      background: "#F4F4F4",
                      color: "#94a3b8",
                      cursor: "not-allowed",
                      padding: "10px 28px",
                      fontWeight: 600,
                    }
              }
            >
              {isLoading?.status === "inprogress" ? <Loading /> : "SAVE"}
            </Button>
          </SBottom>
        </SFooter>
      </SContent>
    </SContainer>
  );
};
export default AdminPopup;
const SFooter = styled.div`
  background-color: var(--color-surface);
  padding: 16px 24px;
  border-top: 1px solid var(--color-border);
`;
const SAddDomain = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 14px;
  padding: 6px 0;
  margin-top: 4px;
  transition: color var(--transition);
  &:hover {
    color: var(--color-primary-hover);
  }
`;
const SIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-xs);
  transition: background-color var(--transition);
  &:hover {
    background: var(--color-danger-soft);
  }
  & > img {
    width: 18px;
    height: 18px;
  }
`;
const STopic = styled.div`
  font-weight: 500;
  font-size: 13px;
  color: var(--color-text-muted);
  margin-bottom: 6px;
`;
const SFieldContainer = styled.div`
  margin-bottom: 20px;
`;
const SAlert = styled.div`
  font-size: 11px;
  color: var(--color-danger);
  margin-top: 4px;
`;
const SSuggestion = styled.div`
  font-size: 11px;
  color: var(--color-text-subtle);
  margin-top: 4px;
`;
const SInputContainer = styled.div`
  height: 40px;
  margin: 4px 0 8px 0;
  display: flex;
  align-items: center;
  position: relative;
`;
const SField = styled.div`
  display: flex;
`;
const SSide = styled.div`
  width: 50%;
  &.oneside {
    width: 100%;
  }
  height: 100%;
  padding: 24px;
`;
const SBottom = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 4px 0;
  gap: 12px;
`;
const SExit = styled.div`
  cursor: pointer;
  background: var(--color-surface-alt);
  color: var(--color-text-muted);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
  line-height: 1;
  transition:
    background-color var(--transition),
    color var(--transition);
  &:hover {
    background: var(--color-danger-soft);
    color: var(--color-danger);
  }
`;
const SLabel = styled.div`
  font-family: "Poppins", "Inter", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: var(--color-text);
`;
const SHeader = styled.div`
  padding: 20px 24px;
  border-bottom: solid 1px var(--color-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SContent = styled.div`
  background-color: var(--color-surface);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  width: 80%;
  max-width: 900px;
  height: fit-content;
  max-height: 90vh;
  &.oneside {
    width: 90%;
    max-width: 460px;
  }
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  display: flex;
  flex-direction: column;
  animation: popIn 220ms cubic-bezier(0.4, 0, 0.2, 1);
  @keyframes popIn {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;
const SContainer = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
  background-color: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`;
